import { isTouchDevice } from '@/web/utils/detect-device';
export const draggableDelay = isTouchDevice() ? 500 : 0;
